import React, { useRef } from 'react'
import {MdLockOutline} from 'react-icons/md'
import { useEffect, useState } from 'react';
import { useNavigate,useLocation, Link } from 'react-router-dom';
import api from '../API/api';
import Loader from '../Modals/Loader';
import Alert from '../Modals/Alert';

import { object, string, number, date, InferType,array ,bool} from 'yup';

export const LoginPasswordReset = () => {
  const [token,setToken] = useState(null);
  const [password,setPassword] = useState('');
  const [confirmpassword,setconfirmPassword] = useState('');
  const alertRef = useRef()
  const loaderRef = useRef()

  const navigate = useNavigate()
  const [alertMessage,setalertMessage] = useState(null)
  const location = useLocation();
  const user = location.state
  //const state = location.state

  const userSchema = object({
    password:string().required('Password is required'),
    confirmPassword:string().required('Confirmation Password is required'),
    username:string().required('User Name is required').min(4,'Username must have not less than 4 letters'),
    
    })

  const data = {
    username:user.username,
    password:password,
    confirmPassword:confirmpassword,
  }


  const updatePassword = async (e) =>{
    e.preventDefault()

    //else send to back-end
    try{

        if(password.trim().length === 0 || password == null ){
            setalertMessage('Password cannot be empty')
            alertRef.current.toggleState()
            return
    
          } else {
            if(confirmpassword.trim().length === 0 || password == null){
                setalertMessage('Confirm Password')
                alertRef.current.toggleState()
                return
            } else {
                if(confirmpassword != password){
                    setalertMessage('Passwords Do not match')
                    alertRef.current.toggleState()
                    return
                }
            }
        }
    
      const user = await userSchema.validate(data)
      console.log(user)
      const response = await api.post(`/users/passwordlogin`,data);
      console.log(response)
      if(response.request.status === 200){
        navigate(`/login`)
      }

    } catch(err){
      console.log(err)
      return
    }
    
  }

  useEffect(()=>{
    console.log(user.username)
    setToken('mckewmlkmdlqwmdqmdkwqdrfw')
  },[])

  return (
    <>
      <div className="flex flex-col w-full items-center justify-center text-center min-h-screen bg-gray-100 py-2 px-20">
      <div className="bg-white rounded-2xl shadow-2xl flex w-2/3 max-w-4xl">
        <div className="w-3/5 p-5">
          <div className="text-left font-bold">
          Propel Health
          </div>
          <div className="py-10">
            <h2 className="font-bold text-3xl mb-6">Change Account Password</h2>
            {/*Social media login section*/}
            <p className="text-gray-400 font-semibold my-3">or use your email</p>
            <div className="flex flex-col items-center">
              <div className="bg-gray-100 w-64  flex items-center mb-3">
                <input onChange={(e)=>setPassword(e.target.value)} type="password" name="Password" placeholder="Enter New Password" 
                className="bg-gray-100 py-2.5 px-3 border border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" ></input>
              </div>
              <div className="bg-gray-100 w-64  flex items-center mb-3">
                <input onChange={(e)=>setconfirmPassword(e.target.value)} type="password" name="confirm Password" placeholder="Confirm Password" 
                className="bg-gray-100 py-2.5 px-3 border border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black"  ></input>
              </div>
              <a onClick={(e)=>updatePassword(e)} href="#" className="border-2 border-precision rounded-full px-12 py-2 inline-block font-semibold hover:bg-precision hover:text-white disabled:cursor-not-allowed" >Reset Password</a>
            </div>
          </div>
        </div>
        <div className="w-2/5 bg-[#1C1C1C] text-white rounded-tr-2xl rounded-br-2xl py-36 px-12">
          <h3 className="text-3xl font-bold mb-2">Propel Health</h3>
          <div className="border-2 w-40 border-white inline-block"></div>
        </div>
      </div>
    </div>
    <Loader ref={loaderRef}/>
    <Alert ref={alertRef} message={alertMessage}/>
    </>
    
  )
}
